import { useSelector } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'

export const ProtectedRoutes = () => {
  const User = useSelector(state => state.User)
  let isUserLoggedIn = User.user_name
  return (
    isUserLoggedIn != null ? <Outlet /> : <Navigate to='/login' />
  )
}